import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AdjusterListModule } from '@amfam/claim/shared/adjuster-list';
import { ClaimSharedClaimListModule } from '@amfam/claim/shared/claim-list';
import { PolicyPipesModule } from '@amfam/policy/pipes';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { QuickLinksModule } from '@amfam/shared/ui/quick-links';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { ClaimActivityComponent } from './components/claim-activity/claim-activity.component';
import { ClaimHelpComponent } from './components/claim-help/claim-help.component';
import { ClaimPhotoSummaryComponent } from './components/claim-photo-summary/claim-photo-summary.component';
import { ClaimPostFnolCtaComponent } from './components/claim-post-fnol-cta/claim-post-fnol-cta.component';
import { ClaimProgressTrackerComponent } from './components/claim-progress-tracker/claim-progress-tracker.component';
import { ClaimStatusGeneralComponent } from './components/claim-status-general/claim-status-general.component';
import { ClaimStatusPaymentsComponent } from './components/claim-status-payments/claim-status-payments.component';
import { ClaimStatusRentalcarComponent } from './components/claim-status-rentalcar/claim-status-rentalcar.component';
import { ClaimStatusTowingRepairShopsComponent } from './components/claim-status-towing-repair-shops/claim-status-towing-repair-shops.component';
import { AutoClaimStatusComponent } from './containers/auto-claim-status/auto-claim-status.component';
import { ClaimDetailComponent } from './containers/claim-detail/claim-detail.component';
import { PropertyClaimStatusComponent } from './containers/property-claim-status/property-claim-status.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    AdjusterListModule,
    ImpersonationModule,
    PipesModule,
    ClaimSharedClaimListModule,
    DsRouterLinkModule,
    PolicyPipesModule,
    QuickLinksModule
  ],
  declarations: [
    AutoClaimStatusComponent,
    ClaimActivityComponent,
    ClaimPhotoSummaryComponent,
    ClaimPostFnolCtaComponent,
    ClaimProgressTrackerComponent,
    ClaimStatusGeneralComponent,
    ClaimStatusPaymentsComponent,
    ClaimStatusRentalcarComponent,
    ClaimStatusTowingRepairShopsComponent,
    ClaimHelpComponent,
    ClaimDetailComponent,
    PropertyClaimStatusComponent
  ],
  exports: [AutoClaimStatusComponent]
})
export class ClaimDetailFeatureModule {}
